import { useTranslation } from 'react-i18next';

import { FilterActions, PrioritySelect, DatesSelect, CustomSelect } from 'libs/ui';
import { FilterInputsBox, FilterInputs, ClearFilters } from 'components/shared/filter';
import { DescriptionInput, NumberInput, SignalsHistoryFilterBox } from './filter.styled';

const SignalsHistoryFilter = (props) => {
  const { t } = useTranslation();
  const { filter, target } = props;
  // console.log('🚀 ~ SignalsHistoryFilter ~ filter:', filter.time_from);

  const equipmentItems = [
    { value: '', name: t('filters.Все') },
    { value: 'rack.lane', name: t('filters.Стойка') },
    { value: 'rack.payment', name: t('filters.Паркомат') },
    { value: 'rack.cashbox', name: t('filters.Касса') },
    { value: 'rack.server', name: t('filters.Сервер') },
  ];

  return (
    <SignalsHistoryFilterBox disabled={props.refreshActive}>
      <FilterInputsBox>
        <FilterInputs>
          <p>{t('filters.Начало события')}</p>
          <DatesSelect from={filter.time_from} to={filter.time_to} updateFilter={props.updateFilter} />
        </FilterInputs>

        {!target && (
          <>
            <FilterInputs>
              <p>{t('filters.Оборудование')}</p>
              <CustomSelect value={filter.equipment_type} onChange={(v) => props.updateFilter('equipment_type', v)} items={equipmentItems} style={{ width: '140px' }} />
            </FilterInputs>
            <FilterInputs>
              <p>{t('filters.Номер')}</p>
              <NumberInput value={filter.source} onChange={(e) => props.updateFilter('source', e.target.value)} />
            </FilterInputs>
          </>
        )}

        <FilterInputs style={{ width: '110px' }}>
          <p>{t('filters.Приоритет')}</p>
          <PrioritySelect value={filter.type} onChange={(val) => props.updateFilter('type', val)} />
        </FilterInputs>

        <FilterInputs style={{ margin: '0px' }}>
          <p>{t('windows.Описание сигнала')}</p>
          <DescriptionInput value={filter.message} onChange={(e) => props.updateFilter('message', e.target.value)} />
        </FilterInputs>

        <FilterActions active={props.refreshActive}>
          {props.refreshInput}
          <ClearFilters onClick={props.resetFilter} className="with-refresh">
            <div />
            <p>{t('buttons.Сбросить')}</p>
          </ClearFilters>
        </FilterActions>
      </FilterInputsBox>
    </SignalsHistoryFilterBox>
  );
};

export default SignalsHistoryFilter;
